import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const lineChartTool: Tool = {
  id: "line-chart",
  name: () => m.line_tool_name(),
  description: () => m.line_tool_description(),
  icon: "📈",
  basePath: "/line-chart",
  status: "stable",
  tags: ["chart", "plot", "data-visualization", "line-chart", "science"],
};
